import { usePdfGenerationByType } from './usePdfGeneration';

/**
 * 後方互換のための薄いラッパー。
 * 実装は usePdfGenerationByType に一本化。
 */
export const useRirekishoPdfGeneration = () => {
  const result = usePdfGenerationByType('rirekisho');
  return {
    ...result,
    generateRirekishoPdfDebounced: result.generatePdfDebounced,
    generateRirekishoPdfImmediate: result.generatePdfImmediate,
    generateRirekishoPdfAsync: result.generatePdfAsync,
  };
};
